import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseThreatEmulation from '../../AbstractObjects/GatewayPlan/InnerPages/BaseThreatEmulation';

const pageSchema = PlanGetSchema.pages.threatEmulation;
const pageId = pageSchema.pageId;

function PlanThreatEmulation({
    planObject,
    setPlanData,
    setEditorPageId
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseThreatEmulation
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanThreatEmulation;